import { render, staticRenderFns } from "./bcloud-pc.vue?vue&type=template&id=e4d5fc38"
import script from "./bcloud-pc.vue?vue&type=script&lang=js"
export * from "./bcloud-pc.vue?vue&type=script&lang=js"
import style0 from "./bcloud-pc.vue?vue&type=style&index=0&id=e4d5fc38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports